import React from 'react';
import {Link} from "react-router-dom";

/**
 * React component that a responsive grid
 *
 * @param prop.items An array of objects that is be used to populate this grid.
 * Each object should contain title and contents fields. The field item.content
 * should have link and text fields.
 * @return JSX
 */
export function TopicsTable(props) {
    let {items} = props;

    return (
          <div className="topicTable">
            {items.map((item, index) => (
              <div key={index} className="topicTableColumn">
                <h2 className="topicTableColumnTopic"> {item.title.toUpperCase()} </h2>
                <ul>
                  <div className="topicTableSubtopicContainer" key={index}>
                  {item.contents.map((topic, i) =>(
                    <div className="topicTableSubtopicContainer" key={i+100}><li key={i}>
                      <button className="topicTableColumnSubtopic">
                        {topic.link
                         ?
                          (<Link to={topic.link}>{topic.text}</Link>)
                         : topic.email
                           ?
                            (<a href={`mailto:${topic.email}`}>{topic.text}</a>)
                           : (topic.text)}
                      </button>
                    </li></div>
                  ))}
                  </div>
                </ul>
              </div>
            ))}
          </div>
    );
};
